export class ReviewUtils {
  public static readonly positiveRating: number = 0.6
  public static isRatingPositive(rating: number): boolean {
    return rating > this.positiveRating
  }
}
